module.exports = __webpack_public_path__ + "static/media/map_icon_car.7c0b4cef.png";